import { AuthLayout } from "../components/ui/auth-layout"
import OtpVerify from "../components/auth/otp-verify"

export default function OtpVerifyPage() {
  return (
    <AuthLayout title="Welcome Back" subtitle="Sign in to your VirtualScribe account" showBackButton={true}>
      <OtpVerify />
    </AuthLayout>
  )
}
